import { compose } from 'recompose';
import { query } from './API';
import ImageUpload from './ImageUpload';
import withRequestTracker from '../../../utils/composition/withRequestTracker';

const composedImageUpload = compose(withRequestTracker({ query }))(ImageUpload);

export default composedImageUpload;
